import { m } from "#/paraglide/messages";
import { createServerFn } from "@tanstack/react-start";
import { authMiddleware } from "#/modules/util.auth/middleware.auth";
import { toastErrorMiddleware } from "#/modules/util.errors/middleware.toast-errors";
import { apiFailure } from "#/modules/util.errors/api-failure.server";
import { Result } from "better-result";
import { toResult } from "#/modules/util.auth/api-errors";
import { fetchSchoolLessonsMatchingLessonsOverviewTabFilters } from "#/modules/school.lessen/api.lessen.server";
import type { LessonsSearch } from "#/modules/school.lessen/schema.search";
import { client } from "#/modules/util.fetch-client/fetch-client.server";

/** Lessons overview loader: the lessen matching the Verleden / Alles tab in the URL. */
export const getLessonsOverview = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .validator((data: LessonsSearch) => data)
  .handler(async ({ data }) => {
    const result = await fetchSchoolLessonsMatchingLessonsOverviewTabFilters(data);
    if (Result.isError(result)) throw result.error;
    return { lessons: result.value.data ?? [] };
  });

export const deleteLessons = createServerFn({ method: "POST" })
  .middleware([authMiddleware, toastErrorMiddleware])
  .validator((data: { lessonIds: string }) => data)
  .handler(async ({ data }) => {
    if (!data.lessonIds) {
      throw new Error(m["lessen.geen_les_geselecteerd"]());
    }

    const result = toResult(
      await client.DELETE("/school/lessen", {
        body: [data.lessonIds],
      }),
    );

    if (Result.isError(result)) return apiFailure(result.error);
  });
